import { render, staticRenderFns } from "./attack.vue?vue&type=template&id=f66d5342"
import script from "./attack.vue?vue&type=script&lang=js"
export * from "./attack.vue?vue&type=script&lang=js"
import style0 from "./attack.vue?vue&type=style&index=0&id=f66d5342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports